import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntToFixedNumberPipe} from "./int-to-fixed-number.pipe";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntToFixedNumberPipe
  ],
  exports: [
    IntToFixedNumberPipe
  ]
})
export class IntToFixedNumberModule {}
